import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { RolesPermissionPartialState } from './roles-permissions.reducer';
import { loadingRolesPermissions } from './roles-permissions.actions';
import { getPermissions, getRole } from './roles-permissions.selector';
import { AuthoritiesArray } from './roles-permissions.state';
import { Observable } from 'rxjs';
import { OrganisationId } from '@portal-front-end/models';
import { getRouteParams } from '../root-store/root-store.selectors';

@Injectable({ providedIn: 'root' })
export class RolesPermissionsStoreFacade {
    
    rolesPermissions$: Observable<AuthoritiesArray> = this.rolePermActions.pipe(select(getPermissions));

    role$: Observable<string> = this.rolePermActions.pipe(select(getRole));

    constructor(private rolePermActions: Store<RolesPermissionPartialState>) { }

    loadPermissions(orgId: OrganisationId) {
        this.rolePermActions.dispatch(loadingRolesPermissions({ orgId }));
    }
}
